<template>
  <div id="app">
    <HeaderNav />
    <main class="main-content">
      <RouterView />
    </main>
    <FooterNav />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import HeaderNav from './components/layout/HeaderNav.vue'
import FooterNav from './components/layout/FooterNav.vue'
</script>

<style scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}
</style>
